import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import axios            from 'axios';
import AppControlService from './AppControl';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class OrdersService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._cart = null;
    this._isAlertFree = false;
    this._isComplete = false;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new OrdersService(singletonEnforcer);
    }
    return this[singleton];
  }

  set alertFree( value ) {
    this._isAlertFree = value;
    this.emit('alertFree', this._isAlertFree);
  }

  get alertFree() {
    return this._isAlertFree;
  }

  get cart() {
    return this._cart;
  }

  get() {
    return new Promise( (resolve, reject) => {
      this.emit('updating');
      if(this._cart && this._cart.items.length === 0) this.emit('updated', null);
      axios.get('/api/v2/orders/me').then( res => {
        this._cart = res.data;
        resolve(res.data);
        const event = new CustomEvent('cart:update', { detail: res.data.items.length });
        document.body.dispatchEvent(event);
        this.emit('updated', res.data);
        if (res.data.items.length === 0) AppControlService.goTo(0);
      }).catch( (err) => {
        this._cart = {};
        this.emit('updated', {});
        console.error(err);
        reject(err);
      });
    })
  }

  confirm() {
    return new Promise( (resolve, reject) => {
      if(this._isComplete) return resolve();
      axios.patch(`/api/v2/orders/${this._cart.id}/complete`, {}, {
        headers: {
          'Content-Type': 'application/merge-patch+json'
        }
      }).then( res => {
        this._isComplete = true;
        resolve(res);
      }).catch(reject);
    });
  }

  promoUpdate(code = null) {
    return new Promise( (resolve, reject) => {
      this.emit('updating');
      const seq = axios.patch(`/api/v2/orders/${this._cart.id}/promotions/apply`, {couponCode: code}, { headers: {
        'Content-Type': 'application/merge-patch+json'
      }});
      seq.then( (res) => {
        this.get().then(() => {
          resolve(res);
        }).catch(reject);
      }).catch( (err) => {
        console.error(err);
        reject(err);
      });
    });
  }

  getShippings() {
    const seq = axios.get(`/api/v2/orders/${this._cart.id}/shippings`);
    seq.catch( console.error );
    return seq;
  }

  update(params = {}) {
    const seq = axios.patch(`/api/v2/orders/${this._cart.id}`, {...params}, { headers: {
      'Content-Type': 'application/merge-patch+json'
    }});
    this.emit('updating');
    seq.then( res => {
      this._cart = res.data;
      const event = new CustomEvent('cart:update', { detail: res.data.items.length });
      document.body.dispatchEvent(event);
      this.emit('updated', res.data);
    }).catch( console.error );
    return seq;
  }

  addItem(datas) {
    const seq = axios.post('/api/v2/orders/items', {...datas});
    seq.catch( console.error );
    return seq;
  }

  updateItem(id, datas) {
    const seq = axios.patch(`/api/v2/orders/${this._cart.id}/items/${id}`, {...datas}, { headers: {
      'Content-Type': 'application/merge-patch+json'
    }});
    seq.catch( console.error );
    return seq;
  }

  deleteItem(id) {
    const seq = axios.delete(`/api/v2/orders/items/${id}`);
    seq.catch( console.error );
    return seq;
  }
}
export default OrdersService.getInstance();